var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Panel from './panel';
import { Seq } from 'immutable';
import { FormLabel, FormSelect, FormNumberInput } from '../style/export';

import { MODE_IDLE } from '../../constants';

var VISIBILITY_MODE = {
    MODE_IDLE: MODE_IDLE
};

var CATALOG_STYLES = {
    containerStyles: {
        width: '100%',
        position: 'unset',
        backgroundColor: 'unset'
    },

    searchContainer: false,

    itemsStyle: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center'
    }

};

var PanelFloors = function (_Component) {
    _inherits(PanelFloors, _Component);

    function PanelFloors(props, context) {
        _classCallCheck(this, PanelFloors);

        var _this = _possibleConstructorReturn(this, (PanelFloors.__proto__ || Object.getPrototypeOf(PanelFloors)).call(this, props, context));

        _this.panelRef = React.createRef();
        var scene = props.state.scene;
        var floors = scene.floors;
        var selectedFloor = scene.selectedFloor;
        var elevation = floors.getIn([selectedFloor, 'elevation']);
        _this.state = {};
        _this.updateSelectedFloor = _this.updateSelectedFloor.bind(_this);
        _this.setElevation = _this.setElevation.bind(_this);
        return _this;
    }

    _createClass(PanelFloors, [{
        key: 'updateSelectedFloor',
        value: function updateSelectedFloor(e) {
            //e.stopPropagation();
            this.context.sceneActions.selectFloor(e);
        }
    }, {
        key: 'setElevation',
        value: function setElevation(e, selectedFloor) {
            this.context.sceneActions.setFloorProperties(selectedFloor, e.target.value);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var scene = this.props.state.scene;
            var selectedFloor = scene.get('selectedFloor');
            var floors = scene.get('floors');
            var elevation = floors.getIn([selectedFloor, 'elevation']);
            return React.createElement(
                Panel,
                { name: this.context.translator.t('Floors'), isDesktop: this.props.isDesktop, opened: true },
                React.createElement(
                    'div',
                    { className: 'floors-table' },
                    React.createElement(
                        'div',
                        { className: 'floor-record' },
                        React.createElement(
                            'div',
                            { className: 'floor-label' },
                            React.createElement(
                                FormLabel,
                                null,
                                this.context.translator.t("Selected floor")
                            )
                        ),
                        React.createElement(
                            'div',
                            { style: { width: '60px' } },
                            React.createElement(
                                FormSelect,
                                { value: selectedFloor, onChange: function onChange(event) {
                                        return _this2.updateSelectedFloor(event.target.value);
                                    } },
                                floors.toArray().map(function (floor, index) {
                                    return React.createElement(
                                        'option',
                                        { key: index, value: floor.id },
                                        floor.name
                                    );
                                })
                            )
                        )
                    ),
                    React.createElement(
                        'div',
                        { className: 'floor-record' },
                        React.createElement(
                            'div',
                            { className: 'floor-label' },
                            React.createElement(
                                FormLabel,
                                null,
                                this.context.translator.t("Elevation") + " (" + scene.unit + ")"
                            )
                        ),
                        React.createElement(
                            'div',
                            { style: { width: '60px', display: 'flex', alignItems: 'center' } },
                            React.createElement(FormNumberInput, {
                                value: elevation,
                                onChange: function onChange(e) {
                                    return _this2.setElevation(e, selectedFloor);
                                }
                            })
                        )
                    )
                )
            );
        }
    }]);

    return PanelFloors;
}(Component);

export default PanelFloors;


PanelFloors.propTypes = {
    state: PropTypes.object.isRequired,
    isDesktop: PropTypes.bool.isRequired
};

PanelFloors.contextTypes = {
    catalog: PropTypes.object.isRequired,
    translator: PropTypes.object.isRequired,
    projectActions: PropTypes.object.isRequired,
    sceneActions: PropTypes.object.isRequired
};